import React from "react";
import { Link } from "react-router-dom";
import { Globe, Info } from "lucide-react";
import { PRIMARY } from "../shared/kursusUi";
import { LANG_CODES, LANG_PACKS, langCoursePath } from "../../data/lang";

/** Pris i DKK formateret efter sidens eget sprog. */
export const money = (n, numLocale = "en-GB") =>
  typeof n === "number" && n > 0 ? `${n.toLocaleString(numLocale)} DKK` : null;

export const LangNotice = ({ pack }) => (
  <div className="bg-amber-50 border-b border-amber-200" data-testid="lang-notice">
    <div className="container mx-auto px-4 md:px-6 py-3 flex items-start gap-2.5 text-[13px] sm:text-sm text-amber-900">
      <Info className="h-4 w-4 mt-0.5 shrink-0" />
      <p className="leading-relaxed">{pack.ui.notice}</p>
    </div>
  </div>
);

/**
 * Sprogskifter: de øvrige sprogvarianter af samme side + den danske original.
 * `courseKey` er null på sprogforsiderne.
 */
export const LangSwitcher = ({ pack, courseKey, danishPath, danishLabel }) => {
  const others = LANG_CODES.filter((c) => c !== pack.code);
  return (
    <div className="flex flex-wrap items-center gap-2.5" data-testid="lang-switcher">
      <span className="inline-flex items-center gap-1.5 text-sm text-slate-500">
        <Globe className="h-4 w-4" /> {pack.ui.otherLangs}:
      </span>
      <span
        lang={pack.htmlLang}
        dir={pack.dir}
        aria-current="true"
        className="px-3 py-1.5 rounded-full border border-slate-300 bg-slate-100 text-sm font-semibold text-slate-900 cursor-default"
        data-testid={`lang-switch-${pack.code}`}
      >
        {pack.nativeName}
      </span>
      {others.map((c) => {
        const other = LANG_PACKS[c];
        const to = courseKey ? langCoursePath(c, courseKey) : `/${c}`;
        return (
          <Link
            key={c}
            to={to}
            lang={other.htmlLang}
            dir={other.dir}
            className="px-3 py-1.5 rounded-full border border-slate-200 bg-white text-sm font-medium text-slate-700 hover:border-slate-400 transition-colors"
            data-testid={`lang-switch-${c}`}
          >
            {other.nativeName}
          </Link>
        );
      })}
      <Link
        to={danishPath}
        lang="da"
        dir="ltr"
        className="px-3 py-1.5 rounded-full border text-sm font-medium transition-colors hover:bg-slate-50"
        style={{ borderColor: PRIMARY, color: PRIMARY }}
        data-testid="lang-switch-da"
      >
        {danishLabel}
      </Link>
    </div>
  );
};

export const FactRow = ({ label, children, testid }) => (
  <div className="flex flex-wrap gap-x-4 gap-y-0.5 py-2.5 border-b border-slate-100 last:border-0" data-testid={testid}>
    <dt className="w-full sm:w-52 shrink-0 text-sm text-slate-500">{label}</dt>
    <dd className="flex-1 min-w-0 break-words text-sm font-medium text-slate-800">{children}</dd>
  </div>
);
